import { IBenchmarkResponse } from '../../interfaces/benchmark.interface'
import { ICalendarBenchmarkResponse } from '../../interfaces/calendar.interface'

export interface BenchmarkReportsStateModel {
  benchmark: IBenchmarkResponse
  calendarBenchmark: ICalendarBenchmarkResponse[]
}
